module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Hairline-d580b6dfcbd587d3154d406ea9208766.woff2";